import { makeStyles } from '@material-ui/core/styles'
import useConversationsStore from '@/stores/useConversationsStore'
import ChatList from './conversations-list/chat-list'
import HeaderButtons from './conversations-list/header-buttons'
import { useAwsCredentialsManager } from '../context/AWS-credentials.context'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  header: {
    flexShrink: 0,
  },
  chatListWrapper: {
    flexGrow: 1,
    overflow: 'hidden',
    padding: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
  },
}))

const ConversationsListContainer = () => {
  const classes = useStyles()
  const { isAuthorized } = useAwsCredentialsManager()

  const isSidebarCollapsed = useConversationsStore((state) => state.isSidebarCollapsed)

  if (isSidebarCollapsed || !isAuthorized) {
    return null
  }

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <HeaderButtons />
      </div>
      <div className={classes.chatListWrapper}>
        <ChatList />
      </div>
    </div>
  )
}

export default ConversationsListContainer
